import { UnitTypeShort } from 'dayjs';
import { ElementType, FC, ReactElement } from 'react';

/**
 * Shekel sign for usage across app
 */
export const ShekelSign = '₪';

// general
export interface TotalStat {
  total: number;
  change?: number;
  unit?: string;
}
export interface DataPoint {
  x: string;
  y: number;
}

// Time
export interface TimeSpan {
  count: number;
  timeUnit: TimeUnit;
  custom?: TimeSpanSpecific;
}

export interface TimeSpanSpecific {
  from: string;
  to: string;
}
export type TimeUnit = UnitTypeShort;

export type TimeRange = {
  startTime: Date | null;
  endTime: Date | null;
};

export type TimeFilter = {
  timeUnit: TimeUnit;
  timeRange: TimeRange;
};

// filters
export interface Filters {
  timeSpan?: TimeSpan | null;
}

// perfect-scrollbar
export enum PSClasses {
  RailY = 'ps__rail-y',
  RailX = 'ps__rail-x',
  ThumbY = 'ps__thumb-y',
  ThumbX = 'ps__thumb-x',
}

export interface Option<T> {
  label: string;
  value: T;
  Icon?: ElementType;
  Component?: ReactElement;
}

export enum LocalStorageKeys {
  AccessToken = 'accessToken',
  ExpiryTime = 'expiryTime',
  UserId = 'userId',
  InboxId = 'inboxId',
  Email = 'email',
  AuthToken = 'authToken',
}
